import React, { Fragment, useRef, useState, useEffect } from 'react'
import useOutsideClick from '../../SearchComponent/useOutsideClick'
import useDebouncedSearch from '../../SearchComponent/useDebouncedSearch'

import SearchResults from './SearchResults'

import './style.scss'
import { fetchResponse } from '../../../controllers/shared/utils/fetch_data'
import useAnnounceResults from '../../hooks/useAnnounceResults'

export default function SearchComponent({ currentReportId }) {
  const announce = useAnnounceResults()
  const [hasFocus, setHasFocus] = useState(false)
  const searchFunction = async inputText => {
    const response = await fetchResponse(`/admin/org/reports/search?global_q=${inputText}`)

    if (response.ok) {
      const responseJson = await response.json()
      announce(responseJson.length)
      return responseJson
    }
  }

  const { inputText, setInputText, searchResults } = useDebouncedSearch(searchFunction)
  const ref = useRef()

  useOutsideClick(ref, () => {
    setInputText('')
  })

  const handleElementFocus = (e) => {
    const currentTarget = e.currentTarget

    // Give browser time to focus the next element
    requestAnimationFrame(() => {
      // Check if the new focused element is a child of the original container
      setHasFocus(currentTarget.contains(document.activeElement))
    })
  }

  return (
    <Fragment>
      <div ref={ref} onFocus={handleElementFocus} onBlur={handleElementFocus}>
        <div className='reports-search-box'>
          <i className='fas fa-search form-control-feedback' />
          <input
            type='search'
            aria-label='search reports'
            value={inputText}
            onChange={e => setInputText(e.target.value)}
            placeholder='Search by report name or description...'
            name='report-search'
            className='border-0 ms-3 search-input-component'
            autoComplete='off'
          />
        </div>
        <SearchResults
          inputText={inputText}
          searchResults={searchResults}
          currentReportId={currentReportId}
          hasFocus={hasFocus}
        />
      </div>
    </Fragment>
  )
}
